import {useAppDispatch, useAppSelector} from '../../../../helpers/appReduxHelpers';
import {getShouldRecommendDeclutter} from '../../../../store/data/workspace/visualWorkspace/visualWorkspaceSelectors';
import {startedEditingWorkspacesAction} from '../../../../store/panels/inboxes/inboxesPanelActions';
import {InboxesPanelProps} from '../../../../store/panels/inboxes/inboxesPanelSelectors';

/*
 * Hooks.
 */

export function useOnEditWorkspace<P extends InboxesPanelProps>(props: P) {
  const dispatch = useAppDispatch();
  const shouldRecommendDeclutter = useAppSelector(getShouldRecommendDeclutter);

  const onEditWorkspace = () => {
    dispatch(startedEditingWorkspacesAction(props.panelId, shouldRecommendDeclutter));
  };

  return onEditWorkspace;
}
